<template>
  <div class="professional-experience">
    <h3 class="professional-experience-title">
      {{ title }} 
      <span class="professional-experience-title-place">{{ place }}</span>
      <span class="professional-experience-title-dates">{{ capitalizeFirstChar(beginDate) }}  - {{ capitalizeFirstChar(endDate) }} ({{ duration }})</span>
    </h3>
    <ul class="professional-experience-description">
      <li v-for="(descItem, ix) in description" :key="`description-item-${ix}`">
        {{ descItem}}
      </li>
    </ul>
    <p class="professional-experience-email">
      <a :href="`mailto:${contact}`">{{ contact }}</a>
    </p>
  </div>
</template> 

<script>
  import useFormat from "@/helpers/format"

  export default {
    name: "ProfessionalExperience",
    props: {
      title: { type: String, required: true },
      beginDate: { type: String, required: true },
      endDate: { type: String, required: true },
      duration: { type: String, required:true },
      place: { type: String, required: true },
      description: { type: Array, required: true },
      contact: { type: String, required: true }
    },
    setup() {
      const { capitalizeFirstChar } = useFormat

      return { capitalizeFirstChar: capitalizeFirstChar }
    }
  }
</script>

<style lang="scss" scoped>
  .professional-experience {
    color: var(--contrast-color);
    border: 1px solid var(--main-color-accent);
    padding: 0 2rem;
    margin: 1rem 0;

    &-title {
      color: var(--main-color-accent);

      &-place {
        color: var(--contrast-color);
        margin-left: 1rem;
        text-transform: uppercase;
      }

      &-dates {
        color: var(--contrast-color);
        font-weight: normal;
        margin-left: 1rem;
      }
    }

    &-email {
      text-align: right;
      
      a, a:hover, a:visited, a:active, a:focus, a:target {
        color: white;
        text-decoration: none;
      }
    }
  }

  @include mobile {
    .professional-experience {
      padding: 0 1rem;

      &-title {
        text-align: center;
        color: var(--main-color-accent);

        &-place {
          display: block;
          margin-top: 0.5rem;
        }

        &-dates {
          margin-top: 0.5rem;
          display: block;
        }
      }
    }
  }
</style>